import { FieldValues } from 'react-hook-form'
import {
  ControlledSelect,
  ControlledSelectProps,
} from '../Select/ControlledSelect'
import { useIntl } from 'react-intl'

type MarketingAttributionSelectProps<T extends FieldValues> = Pick<
  ControlledSelectProps<T>,
  'name' | 'options' | 'control'
>

export function MarketingAttributionSelect<T extends FieldValues>({
  name,
  control,
  options,
}: MarketingAttributionSelectProps<T>) {
  const intl = useIntl()
  return (
    <ControlledSelect
      control={control}
      name={name}
      rules={{ required: true }}
      placeholder={intl.formatMessage({
        id: 'boarding.form.marketingAttribution.placeholder',
        defaultMessage: 'Select an option',
      })}
      margin="both"
      options={options}
      randomize={true}
    />
  )
}
